<ui-button variant="ghost" extraButtonClasses="w-full rounded-sm !bg-gray-000" (click)="openTradingTime()">
	<span class="leading-none pt-1 text-sm font-medium text-gray-700" data-cy="app-clock-time">{{ clock() }}</span>
	<ui-icon
		width="22"
		height="22"
		data-cy="app-clock-icon"
		[class]="'shrink-0 ' + colorClass()"
		[iconName]="iconName()"
		[attr.title]="tooltip()"
		[attr.aria-label]="tooltip()" />
</ui-button>

<app-trading-time-bottom-sheet #tradingTime [currentTime]="currentTime()" [symbol]="symbol()" />
